<div mat-dialog-content>
  <lemon-dialog-header>
    {{ 'asetukset.uusi-laskutusprofiili.otsikko' | translate | async }}
  </lemon-dialog-header>
  <form class="lisays-lomake" (ngSubmit)="luoUusiProfiili()" novalidate>
    <mat-form-field>
      <mat-label>{{ 'asetukset.uusi-laskutusprofiili.nimi' | translate | async }}</mat-label>
      <input type="text" [formField]="lomake.nimi" matInput cdkFocusInitial [placeholder]="'asetukset.uusi-laskutusprofiili.nimi-placeholder' | translate | async" />
    </mat-form-field>
    <div class="ohje">{{ 'asetukset.uusi-laskutusprofiili.ohje' | translate: { lahdeprofiili: data.lahdeprofiilinNimi } | async }}</div>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button class="secondarybutton" mat-button mat-dialog-close>{{ 'yleiset.peruuta' | translate | async }}</button>
  <button class="primarybutton" mat-button [disabled]="lomake().invalid()" (click)="luoUusiProfiili()">{{ 'asetukset.uusi-laskutusprofiili.luo' | translate | async }}</button>
</div>
